import React, { useState } from "react";
import edAdmin from "../assets/img/portfolio/EdAdminHub Website.svg";
import event1 from "../assets/img/portfolio/event1.jpg";
import event2 from "../assets/img/portfolio/event2.jpg";
import event5 from "../assets/img/portfolio/event5.jpg";
import event6 from "../assets/img/portfolio/event6.jpg";
import vikram0 from "../assets/img/portfolio/Vikram0.webp";
import vikram1 from "../assets/img/portfolio/Vikram1.jpg";
import vikram2 from "../assets/img/portfolio/Vikram2.jpg";
import vikram3 from "../assets/img/portfolio/Vikram3.jpg";
import vikram4 from "../assets/img/portfolio/Vikram4.jpg";

const portfolioItems = [
  { imgSrc: edAdmin, filter: "filter-app", gallery: "portfolio-gallery-app" },
  {
    imgSrc: edAdmin,
    filter: "filter-product",
    gallery: "portfolio-gallery-product",
  },
  {
    imgSrc: event1,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: event2,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: event5,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: event6,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: vikram0,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: vikram1,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: vikram2,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: vikram3,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
  {
    imgSrc: vikram4,
    filter: "filter-event",
    gallery: "portfolio-gallery-event",
  },
];

const PortfolioSection = () => {
  const [activeFilter, setActiveFilter] = useState("*");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState("");

  const openModal = (src) => {
    setModalImageSrc(src);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImageSrc("");
  };

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  //=================== main_return_function =============//
  return (
    <section id="portfolio" className="portfolio section font-[poppins]">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <div className="flex flex-col justify-center items-center mb-2">
          <h2 className="font-[poppins] !font-bold !text-[24px] md:!text-[34px]">
            Our
            <span className="font-[Playfair] ml-1 italic text-[#9bd66c]">
              Portfolio
            </span>
          </h2>
          <div className=" w-14 h-1 bg-[#9bd66c] mb-2"></div>
        </div>
        <p>
          Discover how our innovative solutions and design expertise bring ideas
          to life. Each project showcases our dedication to technology,
          creativity, and excellence.
        </p>
      </div>
      {/* End Section Title */}

      <div className="container-fluid">
        <div
          className="isotope-layout"
          data-default-filter="*"
          data-layout="masonry"
          data-sort="original-order"
        >
          {/* Portfolio Filters */}
          <ul
            className="portfolio-filters isotope-filters"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <li
              data-filter="*"
              className={`filter-active ${
                activeFilter === "*" ? "filter-active" : ""
              }`}
              onClick={() => handleFilterClick("*")}
            >
              All
            </li>
            <li
              data-filter=".filter-app"
              className={`${
                activeFilter === ".filter-app" ? "filter-active" : ""
              }`}
              onClick={() => handleFilterClick(".filter-app")}
            >
              App
            </li>
            <li
              data-filter=".filter-product"
              className={`${
                activeFilter === ".filter-product" ? "filter-active" : ""
              }`}
              onClick={() => handleFilterClick(".filter-product")}
            >
              Product
            </li>
            <li
              data-filter=".filter-event"
              className={`${
                activeFilter === ".filter-event" ? "filter-active" : ""
              }`}
              onClick={() => handleFilterClick(".filter-event")}
            >
              Event
            </li>
          </ul>
          {/* End Portfolio Filters */}

          <div
            className="row g-0 isotope-container"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            {portfolioItems
              .filter(
                (item) =>
                  activeFilter === "*" || `.${item.filter}` === activeFilter
              )
              .map((item, index) => (
                <div
                  key={index}
                  className={`col-xl-3 col-lg-4 col-md-6 portfolio-item isotope-item ${item.filter}`}
                >
                  <div className="portfolio-content flex items-center justify-center">
                    <img
                      src={item.imgSrc}
                      onClick={() => openModal(item.imgSrc)}
                      className="w-full h-60 object-cover cursor-pointer block"
                      alt="portfolio"
                    />
                  </div>
                </div>
              ))}
          </div>

          {/* End Portfolio Container */}
        </div>
      </div>
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div
            className="relative w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={modalImageSrc}
              alt="Preview"
              className="w-full h-full object-contain"
            />
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-white text-4xl bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-80"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default PortfolioSection;
